export function prepareTransplantHtml(rawHtml, rewriteHref) {
  const innerDocument = document.createElement('section');
  innerDocument.innerHTML = rawHtml;

  innerDocument.querySelectorAll('[rel="stylesheet"]').forEach((style) => {
    style.setAttribute('href', rewriteHref(style.href));
  });
  innerDocument.querySelectorAll('img').forEach((image) => {
    image.setAttribute('src', rewriteHref(image.src));
  });
  innerDocument.querySelectorAll('script').forEach((script) => {
    if (script.src) {
      script.setAttribute('src', rewriteHref(script.src));
    }
  });
  innerDocument.querySelectorAll('a').forEach((link) => {
    link.setAttribute('href', rewriteHref(link.href));
  });

  const template = document.implementation.createHTMLDocument('');
  template.documentElement.innerHTML = innerDocument.innerHTML;

  return '<!DOCTYPE html>' + template.documentElement.outerHTML;
}

export function writeTransplantDocument(iFrameDocument, documentHtml) {
  iFrameDocument.open();
  iFrameDocument.write(documentHtml);
  iFrameDocument.close();
}

export function verifyTransplantStylesSync(iFrameDocument) {
  if (!iFrameDocument.defaultView) {
    return false;
  }

  // Only verify inline styles. External stylesheets may be unavailable offline
  // or still loading; they are optional and not a transplant failure signal.
  for (const styleTag of iFrameDocument.querySelectorAll('style')) {
    if (!styleTag.sheet) {
      return false;
    }
  }

  return true;
}

export function verifyTransplantApplied(iFrameDocument) {
  return new Promise((resolve) => {
    const check = () => resolve(verifyTransplantStylesSync(iFrameDocument));

    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => requestAnimationFrame(check));
      return;
    }

    setTimeout(check, 0);
  });
}
